import { useQuery } from '@tanstack/react-query'
import { photosService } from '@/api/services/photos.service'
import { queryKeys } from '@/api/query-keys'

export function usePhotoAlbumsQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.photos.albums(),
    queryFn: () => photosService.getAlbums(),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
